import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: null,
  error: null,
};

const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    initialize: () => initialState,
    changeProp: (state, { payload: { key, value } }) => {
      state[key] = value;
    },
  },
});

export const { initialize, changeProp } = notificationSlice.actions;

export default notificationSlice.reducer;
